/**
 * Create function to set all refs to new value.
 * @param refsToSet
 * @returns
 */
export function combineRefs(...refsToSet) {
    return (instance) => {
        if (!refsToSet?.length) {
            return;
        }
        refsToSet.forEach((refToSet) => {
            if (!refToSet) {
                return;
            }
            if (typeof refToSet === 'function') {
                return refToSet(instance);
            }
            if (instance) {
                // Required to allow ".current" to be assigned.
                refToSet.current = instance;
            }
        });
    };
}
